import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "Please click and shift the virtual sound source (blue) between the three loudspeakers and listen to the changes through headphones, you can also see the changes of the amplitude in green next to each loudspeaker. With this amplitude weighting a virtual sound source will be created for the listener’s position in red.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0322/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
